import { SubmitClaim } from "commonAssets/components/Forms/SubmitClaim";
import { FormBase } from "commonAssets/components/FormBase";
import { createElement } from "commonAssets/lib/createElement";
import { modal } from "commonAssets/lib/modal";
import { loadingGif } from "commonAssets/lib/loadingGif";
import { validateField } from "commonAssets/lib/validateField";
import { clearMessage } from "commonAssets/lib/clearMessage";
import { toggleFieldError } from "commonAssets/lib/toggleFieldError";
import { loadMember } from "commonAssets/lib/loadMember";
import { ConfirmEmailAddress } from "commonAssets/lib/ConfirmEmailAddress";
import { localDatetime } from "commonAssets/lib/localDatetime";
import { generateMd5Hash } from "commonAssets/lib/generateMd5Hash";
import { toggleFieldWarning } from "commonAssets/lib/toggleFieldWarning";
import { removeClaimFile } from "commonAssets/lib/removeClaimFile";
import { uploadFile } from "commonAssets/lib/uploadFile";
import { validOTP } from "commonAssets/lib/validOTP";
import { createOTPForm } from "commonAssets/lib/createOTPForm";
import { uniformClaimDeadline } from "commonAssets/lib/uniformClaimDeadline";
import {
    i18n,
    loading,
    outputDiv,
    reCAPTCHAv3,
    appPayMethod
} from "commonAssets/js/constants";
import {
    dstPaymentIframeTitle,
    dstMember,
    dstProcess,
    DigitalDisbursements
} from "commonAssets/components/FormBase/DigitalDisbursements";
import { ErrorHandler } from "commonAssets/utils/ErrorHandler";
import formDefault from "../../docs/formDefault.json";
import { toggleFieldAttributeV2 } from "commonAssets/lib/toggleFieldAttributeV2";

let proofOfPurchase, proofOfPurchaseNumber, proofOfPurchaseTotal, noProofOfPurchase, previousReimbursement, amountPreviouslyReimbursed, transactionTable, uploadWidget;

export class customSubmitClaim extends SubmitClaim {
    async form() {
        const form = formDefault.claim_form[this.lang];
        this.init_claim(form);
    }

    static createInstance({
        appClaimForm,
        userLanguage,
        customInitClaim = null,
        customProcessClaim = null,
        customLoadMember = null,
        customDstProcess = null,
        errorHandler = new ErrorHandler(),
    }) {
        return new customSubmitClaim(
            appClaimForm,
            userLanguage,
            customInitClaim,
            customProcessClaim,
            customLoadMember,
            customDstProcess,
            errorHandler
        );
    }

    init_claim(form) {
        this.claim.api
            .claimsDeadlineGet({ domain: this.claim.data.domain })
            .then((result) => {
                let datetime;
                if (Boolean(result.data.pacific_datetime)) {
                    datetime = result.data.pacific_datetime;
                } else {
                    datetime = `<pre>Error: datetime</pre>`;
                }

                let claim_deadline;
                if (Boolean(result.data.claim_deadline)) {
                    claim_deadline = result.data.claim_deadline;
                }

                if (result.data.error) {
                    this.setup_result_data_error(result);
                    return;
                }

                const container = createElement("div", {
                    class: "display-form",
                });

                if (form.form_options.notice_confirmation.display === true) {
                    container.appendChild(this.guard(form, datetime));
                    outputDiv.appendChild(container);

                    const zero_zero_id = document.getElementById("zero_zero_id");
                    const confirmation_code = document.getElementById("confirmation_code");
                    const skip_guard = document.getElementById("skip-guard");

                    [zero_zero_id, confirmation_code].forEach(function (input) {
                        input.addEventListener("change", validateField);
                    });

                    if (skip_guard) {
                        skip_guard.addEventListener("click", () => {
                            document.getElementById("guard").remove();
                            container.appendChild(this.claim_form(form, datetime));
                            container.scrollIntoView({ behavior: "smooth" });
                            outputDiv.appendChild(container);
                            this.init_claim_fields(this.claim, form, claim_deadline);
                        });
                    }

                    document
                        .getElementById("submit-guard")
                        .addEventListener("click", () => {
                            document
                                .getElementById("guard")
                                .classList.add("was-validated");
                        });

                    document
                        .getElementById("guard")
                        .addEventListener("submit", (e) => {
                            e.preventDefault();

                            let valid = true;
                            const member = {
                                domain: this.claim.data.domain,
                                zero_zero_id: zero_zero_id.value.toUpperCase(),
                                confirmation_code: confirmation_code.value,
                            };

                            clearMessage();

                            [zero_zero_id, confirmation_code].forEach(function (input) {
                                valid = validateField(input) && valid;
                            });
                            if (!valid) return;

                            loadingGif(loading, "show");

                            this.claim.api
                                .classMemberPost({}, member)
                                .then((result) => {
                                    if (result.data.error) {
                                        toggleFieldError(zero_zero_id, true, "");
                                        toggleFieldError(confirmation_code, true, "");
                                        this.errorHandler.log_exception(
                                            new Error("Error loading class member", {
                                                cause: result,
                                            })
                                        );
                                        this.errorHandler.display_modal(result);
                                        return;
                                    }

                                    const canEdit = result.data.claim_id
                                        ? result.data.class_member?.can_edit
                                        : result.data.can_edit;
                                    const isDeficient = result.data.claim_id
                                        ? result.data.class_member?.is_deficient
                                        : result.data.is_deficient;

                                    if (!(canEdit == 1 && isDeficient == 1)) {
                                        modal(
                                            i18n.getTranslation("error"),
                                            `<p>Claim filing is closed.</p>`
                                        );
                                        loadingGif(loading, "hide", 250);
                                        return;
                                    }

                                    this.claim.data.zero_zero_id = member.zero_zero_id;
                                    this.claim.data.confirmation_code = member.confirmation_code;

                                    const environment = this.claim.data.domain.split(".")[0];

                                    if (result.data.claim_id) {
                                        this.claim.data.claim_id = result.data.claim_id;
                                        this.claim.class_member = result.data;
                                        if (environment !== "local") {
                                            this.send_otp(
                                                form,
                                                container,
                                                result.data,
                                                claim_deadline
                                            );
                                            return;
                                        }
                                    }

                                    this.populate_claim_form(
                                        form,
                                        container,
                                        result.data,
                                        claim_deadline
                                    );
                                })
                                .catch((error) => {
                                    this.errorHandler.log_exception(
                                        new Error("Error loading class member", {
                                            cause: error,
                                        })
                                    );
                                    this.errorHandler.display_modal(error);
                                });
                        });
                } else {
                    this.edit_claim(form);

                    const deadlineSpan = uniformClaimDeadline(claim_deadline);
                    container.appendChild(this.claim_form(form, deadlineSpan));
                    outputDiv.appendChild(container);

                    this.init_claim_fields(this.claim, form, claim_deadline);
                }

                loadingGif(loading, "hide", 250);
            })
            .catch((error) => {
                this.errorHandler.log_exception(
                    new Error("Error fetching claim deadline", { cause: error })
                );
                this.errorHandler.display(error);
            });
    }

    claim_form(params, additionalParams) {
        console.log("[claim_form]");
        // update the claim form deadline
        const deadline_heading =
            params.form_options.claim_deadline_alert.claim_form;
        const deadline_parser = new DOMParser();
        const deadline_string = deadline_parser.parseFromString(
            deadline_heading,
            "text/html"
        );
        const deadline_date_string = deadline_string.querySelector("span");
        // if deadline_date_string is null, then the deadline is not set
        // the if condition was added due to error in i18n translation
        // TODO: remove this if condition after fixing the i18n translation
        if (deadline_date_string !== null) {
            deadline_date_string.textContent = additionalParams;
        }

        // const the form
        const form = createElement(
            "form",
            {
                class: "needs-validation",
                id: "form",
                method: "post",
            },
            [
                createElement(
                    "h3",
                    {
                        class: "text-center mb-3",
                        id: "claimFormDeadline",
                    },
                    [],
                    deadline_string.body.innerHTML
                ),
                createElement(
                    "div",
                    {
                        class: "alert alert-info text-center fw-bold text-dark",
                        id: "confirmation-email-alert",
                        role: "alert",
                    },
                    [],
                    params.form_options.claim_form.confirmation_email_notice
                ),
                this.claim_instructions(params),
                this.claim_contact_information(params),
                this.claim_fieldset(params),
                // params.claim_transactions
                //     ? this.claim_transactions(params)
                //     : ``,
                params.claim_upload.documentation.required
                    ? this.claim_documentation(params)
                    : ``,
                appPayMethod ? DigitalDisbursements(params) : ``,
                this.claim_certification(params),
            ]
        );
        return form;
    }

    claim_transactions(params) {
        if (params.claim_transactions === undefined) {
            return createElement("div", { class: "d-none" });
        }
        if (params.claim_transactions.length === 0) {
            return createElement("div", { class: "d-none" });
        }

        const fieldset = createElement(
            "div",
            {
                class: "bg-light text-dark border rounded p-3 mb-5",
                id: "transactions",
            },
            [
                // createElement(
                //     "div",
                //     {
                //         class: "h3 mb-3 formTitle",
                //     },
                //     [],
                //     params.form_options.transactions.title
                // ),
                // createElement(
                //     "div",
                //     {
                //         class: "mb-3 formBody",
                //     },
                //     [],
                //     params.form_options.transactions.body
                // ),
            ]
        );

        // For Each Transaction Table
        const claim_transactions = params.claim_transactions;
        let tableID = 0;
        claim_transactions.forEach((table) => {
            tableID++; // Begin count at 1.

            // <div class="table-responsive"></div>
            const divResponsiveTable = createElement("div", {
                class: "table-responsive mb-3",
                id: "table_responsive_" + tableID,
            });

            // <table class="table transactions"></table>
            const tableTransaction = createElement(
                "table",
                {
                    class: "table table-hover transactions caption-top",
                    id: "transactions_" + tableID,
                    "data-table-name": table.name,
                    "data-table-id": tableID,
                },
                [
                    createElement(
                        "caption",
                        { class: "text-dark bg-transparent mb-3" },
                        [],
                        table.description
                    ),
                ]
            );
            divResponsiveTable.appendChild(tableTransaction);

            // <thead class="bg-dark text-light"></thead>
            const tableTHEAD = createElement("thead", {
                class: "table-dark text-light",
            });
            tableTransaction.appendChild(tableTHEAD);

            // <tr> ...Table Data Cells... </tr>
            const theadTR = createElement("tr");
            tableTHEAD.appendChild(theadTR);

            // <th scope="col"></th>
            table.columns.forEach((col) => {
                const column = createElement(
                    "th",
                    { scope: "col" },
                    [],
                    col.title
                );
                theadTR.appendChild(column);

                if (Boolean(col.body)) {
                    const helper = createElement(
                        "span",
                        {
                            class: "d-block fw-normal",
                            style: "font-size:16px;",
                        },
                        [],
                        col.body
                    );
                    column.appendChild(helper);
                }
            });

            // <tbody></tbody>
            const tableTBODY = createElement("tbody");
            tableTransaction.appendChild(tableTBODY);

            // Add rows through a function, so we can attach a button.
            const countRow = 1;
            this.claim_transaction_row(table, tableTBODY, tableID, countRow);

            const add_row = createElement(
                "div",
                {
                    class: "text-center",
                },
                [
                    createElement(
                        "a",
                        {
                            class: "btn btn-primary m-1",
                            id: "add_transactions_" + tableID,
                            role: "button",
                            tabindex: "0",
                            "aria-label":
                                i18n.getTranslation("transaction_add_row") +
                                table.name,
                            tableID: tableID,
                        },
                        [],
                        `<i class="bi bi-plus-circle" tableID="${tableID}"></i> ${table.name}`
                    ),
                    createElement(
                        "a",
                        {
                            // ada compliance updates - added
                            class: "btn btn-danger m-1 disabled", // default to disabled
                            id: "remove_transactions_" + tableID,
                            role: "button",
                            tabindex: "0",
                            "aria-label": i18n.getTranslation(
                                "transaction_delete_row"
                            ),
                            tableID: tableID,
                        },
                        [],
                        `<i class="bi bi-dash-circle" tableID="${tableID}"></i> ${i18n.getTranslation("transaction_delete_row")}`
                    ),
                ]
            );

            // ada compliance updates - added
            this.claim_transaction_row_buttons_events(
                add_row,
                table,
                tableTBODY,
                tableID,
                countRow
            );

            // Append the table to the fieldset
            fieldset.appendChild(divResponsiveTable);
            fieldset.appendChild(add_row);
        });

        return fieldset;
    }

    claim_transaction_row_buttons_events(
        add_row,
        table,
        tableTBODY,
        tableID,
        countRow
    ) {
        // Add row for every click
        add_row.firstChild.addEventListener("click", (event) => {
            countRow++;
            const table_id = event.target.attributes.tableID.value;
            this.claim_transaction_row(table, tableTBODY, table_id, countRow);
            if (countRow > 1) {
                document
                    .querySelector(`#remove_transactions_${table_id}`)
                    .classList.remove("disabled");
                document
                    .querySelector(`#add_transactions_${table_id}`) 
                    .classList.add("disabled");
            }
        });
        // Remove row for every click
        add_row.lastChild.addEventListener("click", (event) => {
            countRow--;
            const table_id = event.target.attributes.tableID.value;
            const table = document.querySelector(`#transactions_${table_id}`);
            const table_rows = table.rows.length;
            const table_tbody = table.querySelector("tbody");
            table_tbody.removeChild(table_tbody.lastChild);
            if (table_rows === 3) {
                document
                    .querySelector(`#remove_transactions_${table_id}`)
                    .classList.add("disabled");
                document
                    .querySelector(`#add_transactions_${table_id}`) 
                    .classList.remove("disabled");
            }
        });
    }

    populate_claim_form(form, container, class_member, claim_deadline) {
        console.log("[populate_claim_form]");
        // set user for error tracking
        this.errorHandler.set_user({
            id: class_member.zero_zero_id,
            email: class_member.email_address,
        });
        // remove guard
        document.getElementById("guard").remove();
        // claim_deadline format December 31, 2024 at 04:00:00 P.M.
        const deadlineSpan = uniformClaimDeadline(claim_deadline);
        // New Claim Form
        container.appendChild(this.claim_form(form, deadlineSpan));
        container.scrollIntoView({ behavior: "smooth" });
        // output
        outputDiv.appendChild(container);
        // hide loading gif
        loadingGif(loading, "hide", 250);
        // Init claim fields
        this.init_claim_fields(this.claim, form, claim_deadline);
        // Load member data into form
        loadMember(class_member);

        // Payment widget
        if (appPayMethod && appPayMethod !== "") {
            dstMember();
        }

        if (class_member.claim_id) {
            if (class_member?.claim_files?.length > 0) this.claim.prev_docs = true;

            proofOfPurchase = document.getElementById("proof_of_purchase_0");
            proofOfPurchaseNumber = document.getElementById("number_of_covered_products");
            proofOfPurchaseTotal = document.getElementById("covered_products_total");
            noProofOfPurchase = document.getElementById("no_proof_of_purchase_0");
            transactionTable = document.querySelector('.transaction-table');
            previousReimbursement = document.getElementById("previous_reimbursement_0");
            amountPreviouslyReimbursed = document.getElementById("amount_previously_reimbursed");
            uploadWidget = document.getElementById("documentation");

            if (proofOfPurchase.checked) {
                [proofOfPurchaseNumber, proofOfPurchaseTotal].forEach((element) => {
                    toggleFieldAttributeV2(element, 'required', true);
                    element.parentElement.classList.remove('d-none');
                });
                uploadWidget.classList.add('d-none');
            }
            if (noProofOfPurchase.checked) {
                transactionTable.classList.remove('d-none');
                transactionTable.querySelectorAll('input, select, textarea').forEach((element) => {
                    toggleFieldAttributeV2(element, 'required', true);
                });
            }
            if (previousReimbursement.checked) {
                toggleFieldAttributeV2(amountPreviouslyReimbursed, 'required', true);
                amountPreviouslyReimbursed.parentElement.classList.remove('d-none');
            }
        }
    }

    init_claim_fields(claim, form, claim_deadline) {
        // Claim Inputs
        this.init_claim_inputs();

        // Loop thru available inputs
        this.init_claim_inputs_loop();

        // Validate phone number
        this.setup_phone_number_validation();

        // Country field toggle
        this.setup_country_field_toggle();

        // Confirm email address
        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("init");
        }

        // Check for file documentation section
        if (document.getElementById("documentation")) {
            // Initialize file uploads
            this.init_claim_files(this.claim);
        }

        dstPaymentIframeTitle(form);

        if (Boolean(document.getElementById("form"))) {
            document.getElementById('form').setAttribute('novalidate', 'true');

            // ada compliance updates - added
            // TODO: review if this is where this belongs
            // if id="submit-claim" is clicked, add was-validated to form class
            document
                .getElementById("submit-claim")
                .addEventListener("click", () => {
                    document
                        .getElementById("form")
                        .classList.add("was-validated");
                });

            document
                .getElementById("form")
                .addEventListener("submit", (process) => {
                    this.process_claim(process, this.claim, claim_deadline);
                });
        }

        document.querySelector('.transaction-table').appendChild(this.claim_transactions(form));

        proofOfPurchase = document.getElementById("proof_of_purchase_0");
        proofOfPurchaseNumber = document.getElementById("number_of_covered_products");
        proofOfPurchaseTotal = document.getElementById("covered_products_total");
        noProofOfPurchase = document.getElementById("no_proof_of_purchase_0");
        transactionTable = document.querySelector('.transaction-table');
        previousReimbursement = document.getElementById("previous_reimbursement_0");
        amountPreviouslyReimbursed = document.getElementById("amount_previously_reimbursed");
        uploadWidget = document.getElementById("documentation");

        if (!proofOfPurchase.checked) {
            [proofOfPurchaseNumber, proofOfPurchaseTotal].forEach((element) => {
                toggleFieldAttributeV2(element, 'required', false);
                element.parentElement.classList.add('d-none');
            });
            uploadWidget.classList.add('d-none');
        }
        if (!noProofOfPurchase.checked) {
            transactionTable.classList.add('d-none');
            transactionTable.querySelectorAll('input, select, textarea').forEach((element) => {
                toggleFieldAttributeV2(element, 'required', false);
            });
        }
        if (!previousReimbursement.checked) {
            toggleFieldAttributeV2(amountPreviouslyReimbursed, 'required', false);
            amountPreviouslyReimbursed.parentElement.classList.add('d-none');
        }
        
        proofOfPurchase.addEventListener("click", (e) => {
            if (e.target.checked) {
                [proofOfPurchaseNumber, proofOfPurchaseTotal].forEach((element) => {
                    toggleFieldAttributeV2(element, 'required', true);
                    element.parentElement.classList.remove('d-none');
                });
                noProofOfPurchase.checked = false;
                transactionTable.classList.add('d-none');
                transactionTable.querySelectorAll('input, select, textarea').forEach((element) => {
                    toggleFieldAttributeV2(element, 'required', false);
                    toggleFieldError(element, false);
                    element.value = '';
                });
                uploadWidget.classList.remove('d-none');
            } else {
                [proofOfPurchaseNumber, proofOfPurchaseTotal].forEach((element) => {
                    toggleFieldAttributeV2(element, 'required', false);
                    element.parentElement.classList.add('d-none');
                    toggleFieldError(element, false);
                    element.value = '';
                });
                uploadWidget.classList.add('d-none');
            }
        });

        noProofOfPurchase.addEventListener("click", (e) => {
            if (e.target.checked) {
                transactionTable.classList.remove('d-none');
                transactionTable.querySelectorAll('input, select, textarea').forEach((element) => {
                    toggleFieldAttributeV2(element, 'required', true);
                });
                proofOfPurchase.checked = false;
                [proofOfPurchaseNumber, proofOfPurchaseTotal].forEach((element) => {
                    toggleFieldAttributeV2(element, 'required', false);
                    element.parentElement.classList.add('d-none');
                    toggleFieldError(element, false);
                    element.value = '';
                });
                uploadWidget.classList.add('d-none');
            } else {
                transactionTable.classList.add('d-none');
                transactionTable.querySelectorAll('input, select, textarea').forEach((element) => {
                    toggleFieldAttributeV2(element, 'required', false);
                    toggleFieldError(element, false);
                    element.value = '';
                });
            }
        });

        previousReimbursement.addEventListener("click", (e) => {
            if (e.target.checked) {
                toggleFieldAttributeV2(amountPreviouslyReimbursed, 'required', true);
                amountPreviouslyReimbursed.parentElement.classList.remove('d-none');
            } else {
                toggleFieldAttributeV2(amountPreviouslyReimbursed, 'required', false);
                amountPreviouslyReimbursed.parentElement.classList.add('d-none');
                toggleFieldError(amountPreviouslyReimbursed, false);
                amountPreviouslyReimbursed.value = '';
            }
        });

        if (this.customInitClaim != null) {
            this.claim = this.customInitClaim(this.claim) || this.claim;
        }

        loadingGif(loading, "hide", 1000);
    }

    init_claim_inputs() {
        const claimInputsContact =
            "#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST";
        const claimInputsFields =
            "#claim-fields input:not([item-id]), #claim-fields textarea, #claim-fields select:not([item-id])";
        const claimInputsFieldsPayment =
            "#payment_method, #payment_token, #payment_email, #payment_phone";
        const claimInputsTransactions =
            "#transactions input, #transactions textarea, #transactions select";

        this.claim.inputs.contact = Array.from(
            document.querySelectorAll(claimInputsContact)
        );
        this.claim.inputs.fields = Array.from(
            document.querySelectorAll(
                claimInputsFields + ", " + claimInputsFieldsPayment
            )
        );
        this.claim.inputs.transactions = Array.from(
            document.querySelectorAll(claimInputsTransactions)
        );
    }

    process_claim(e, claim, deadline) {
        console.log("[process_claim]");

        /**
         * Prevent the default form submission.
         *
         * @var {Event} e - The submit event object.
         * @returns {void}
         */
        e.preventDefault();

        /**
         * Disable the submit button to prevent multiple submissions.
         *
         * Since: 2023.09.25
         *
         * @returns {void}
         */
        document.getElementById("submit-claim").disabled = true;

        // var claim = this.claim;
        if (claim.flags.sent) {
            return;
        }

        clearMessage();

        claim.flags.valid = true;
        claim.data.fields = {};

        this.init_claim_inputs();

        this.format_claim_data(claim);

        claim.data.contact.date = localDatetime();

        if (document.getElementById("documentation")) {
            this.process_claim_files(this.claim);
        }

        if (
            document.getElementById("email_address") &&
            document.getElementById("confirm_email_address")
        ) {
            ConfirmEmailAddress("process", this.claim);
        }

        // if appPayMethod is defined and not empty, we run dstProcess from FormBase/DigitalDisbursements.js
        // if (
        //     appPayMethod &&
        //     appPayMethod !== "" &&
        //     this.customDstProcess === null
        // ) {
        //     claim = dstProcess(this.claim);
        // } else if (
        //     appPayMethod &&
        //     appPayMethod !== "" &&
        //     this.customDstProcess !== null
        // ) {
        //     claim = this.customDstProcess(this.claim);
        // }

        /**
         * Define the environment for the s3 uploader.
         */
        const s3env = this.config.url;

        let custom_errors = '';

        if (!proofOfPurchase.checked && !noProofOfPurchase.checked) {
            custom_errors += `<br>Please select a Proof of Purchase option in Section II.`;
            claim.flags.valid = false;
        }

        let docs_uploaded = this.claim.prev_docs || claim.uploads.length > 0;
        if (proofOfPurchase.checked && !docs_uploaded) {
            custom_errors += `<br>Please upload Proof of Purchase.`
            claim.flags.valid = false;
        }

        if (!document.getElementById('payment_method') || !document.getElementById('payment_token') || !document.getElementById('payment_method').value || !document.getElementById('payment_token').value) {
            custom_errors += `<br>${i18n.getTranslation('payment_select_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('email_address').value && document.getElementById('payment_email').value && document.getElementById('email_address').value.toLowerCase() != document.getElementById('payment_email').value.toLowerCase()) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_email_error')}`;
            claim.flags.valid = false;
        }

        if (document.getElementById('phone_number_1').value && document.getElementById('payment_phone').value && document.getElementById('phone_number_1').value.replace(/\D/g, '') != document.getElementById('payment_phone').value.replace(/\D/g, '')) {
            custom_errors += `<br>${i18n.getTranslation('claim_processing_phone_error')}`;
            claim.flags.valid = false;
        }

        if (claim.flags.valid) {
            grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then((token) => {
                claim.data.token = token;
                this.post_claim(claim, s3env);
            });
        } else {
            document.getElementById('submit-claim').disabled = false;
            var error = document.querySelector('label.error, #file-notice.error, #no-files.error');
            let timeout = 0;
            if (error && typeof error.scrollIntoView == 'function') {
                error.scrollIntoView({ behavior: "smooth" });
                timeout = 500;
            }
            setTimeout(() => {
                modal(i18n.getTranslation('error'), i18n.getTranslation('claim_form_errors') + custom_errors);
            }, timeout);
        }
    }

    destroy_claim(claim) {
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {
            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector("div.display-form").classList.add("d-none");

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            fbq('track', 'Lead');
            gtag_report_conversion();

            setTimeout(() => {
                modal(
                    i18n.getTranslation("confirmation_screen_additional")[
                        "title"
                    ],
                    i18n.getTranslation("confirmation_screen_additional")[
                        "body"
                    ]
                );
            }, 250);
        } else {
            modal(
                i18n.getTranslation("error"),
                i18n.getTranslation("claim_submit_error")
            );
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (const type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(
            document.querySelectorAll('input[type="radio"]'),
            function (radio) {
                radio.setAttribute("disabled", "disabled");
            }
        );

        document
            .getElementById("submit-claim")
            .setAttribute("disabled", "disabled");
    }
}
